const state = {
  sidebar: {
    opened: false,
  },
  config: {
    palette: {
      primary: '#4ae387',
      danger: '#e34a4a',
      info: '#4ab2e3',
      success: '#db76df',
      warning: '#f7cc36',
      white: '#fff',
      black: '#000',
      fontColor: '#34495e',
      transparent: 'transparent',
      lighterGray: '#ddd',
    },
  },
  isLoading: true,
  isLoggedIn: !!localStorage.getItem('token'),
//   email: !!localStorage.getItem('email'),
}

const mutations = {
  setLoading (state, isLoading) {
    state.isLoading = isLoading
  },
  loginUser (state) {
    state.isLoggedIn = true
    state.email = true
  },
  logoutUser (state) {
    state.isLoggedIn = false
    state.email = false
  },
}

const actions = {
}

export default {
  state,
  mutations,
  actions,
}
